import request from '@/utils/request'



export function moduleTree(data) {
  return request({
    url: '/api/sysModule/moduleTree.json',
    method: 'post',
    data
  })
}